export default "__VITE_ASSET__TmUABWoL__"